// One PO line's ticket-less docket-entry row (BUILD_SPEC.md §8.1 amendment R3)
// — used by the "Receive a load" wizard's no-ticket branch (ReceiveLoadWizard.tsx,
// Stuart ruling 2026-08-25: one receive entry point, the weighbridge-ticket step
// optional) to enter what arrived against a PO line with no weighbridge ticket
// (wax/packaging/consumables arriving by delivery note). A plain, hook-free
// presentational component (props only) so it's directly render-testable
// without mocking react-query/auth (see ManualLineRow.test.tsx).
import { Table, Text, TextInput } from '@mantine/core';
import { formatPoLineQtyBasis } from './common';
import { showMoistureField, type ManualLineInput } from './manualReceiptLines';
import type { ProductRow, PurchaseOrderLineRow } from './api';

export function ManualLineRow({
  poLine,
  productLabel,
  product,
  input,
  onChange,
}: {
  poLine: PurchaseOrderLineRow;
  productLabel: string;
  product: ProductRow | undefined;
  input: ManualLineInput;
  onChange: (patch: Partial<ManualLineInput>) => void;
}) {
  const each = poLine.qty != null;
  const showMc = showMoistureField(poLine, product);
  return (
    <Table.Tr>
      <Table.Td>
        <Text size="sm">{productLabel}</Text>
        <Text size="xs" c="dimmed">
          {`${formatPoLineQtyBasis(poLine)} ordered`}
        </Text>
      </Table.Td>
      <Table.Td>
        <TextInput
          size="xs"
          placeholder={each ? 'Units' : 'kg'}
          value={input.qty}
          onChange={(e) => onChange({ qty: e.currentTarget.value })}
          w={110}
        />
      </Table.Td>
      <Table.Td>
        {showMc ? (
          <TextInput size="xs" placeholder="MC %" value={input.mcPct} onChange={(e) => onChange({ mcPct: e.currentTarget.value })} w={90} />
        ) : (
          <Text size="xs" c="dimmed">
            —
          </Text>
        )}
      </Table.Td>
    </Table.Tr>
  );
}
